<template>
    <div class="campaign_form_inputs">
        <div class="title">{{ $t('modules.candidates.campaign.form_title') }}</div>
        <p class="welcome_title">{{ $t('modules.candidates.campaign.form_notice', {company_name: companyName}) }}</p>

        <div class="form_material_container">

            <InputMaterialWrap
                v-model="currentEval.candidate_first_name"
                :label="$t('modules.candidates.campaign.inputLabel1')"
                validate='required'
                input-id="campaignFirstName"
                @input="updateFormData">
            </InputMaterialWrap>

            <InputMaterialWrap
                v-model="currentEval.candidate_last_name"
                :label="$t('modules.candidates.campaign.inputLabel2')"
                validate='required'
                input-id="campaignLastName"
                @input="updateFormData">
            </InputMaterialWrap>

            <InputMaterialWrap
                v-model="currentEval.candidate_email"
                :label="$t('modules.candidates.campaign.inputLabel3')"
                validate='required|email'
                input-id="campaignEmail"
                @input="updateFormData">
            </InputMaterialWrap>

            <InputMaterialWrap
                v-model="currentEval.profile_link"
                :label="$t('modules.candidates.campaign.inputLabel4')"
                input-id="campaignProfileLink"
                @input="updateFormData">
            </InputMaterialWrap>

            <h3 class="uploader_title is-size-5 has-text-left">Ajouter des fichiers</h3>
            <FilesUploader @fileUploaded="handleUploadedFile" />

        </div>


        <button class="button is-info is-outlined" @click="validateEvalForm">
            {{ $t('modules.candidates.campaign.submitEvalForm') }}
        </button>

    </div>

</template>

<script>

import FilesUploader from '@/components/shared/filesUploader/filesUploader'

export default {
    name: 'CampaignForm',
    components: {
        FilesUploader
    },
    data(){
        return {
            campaignFormCompleted: false
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.CandidateStore.campaignEval
        },
        currentPosition(){
            return this.$store.state.CandidateStore.campaignPosition
        },
        companyName(){
            if (this.currentPosition){
                return this.currentPosition.company_name
            }else{
                return ""
            }
        },
        isFormValid(){
            if (this.fields.campaignEmail && this.fields.campaignFirstName && this.fields.campaignLastName){
                return (this.fields.campaignEmail.valid && this.fields.campaignFirstName.valid && this.fields.campaignLastName.valid)
            }else{
                return false
            }
        },
    },
    methods: {
        validateEvalForm(){
            this.$validator.validateAll()
            if (this.isFormValid){
                this.$emit("CampaignFormValidated")
            }else{

            }
        },
        updateFormData(){
            this.$store.commit('CandidateStore/updateCampaignData', this.currentEval )
        },
        handleUploadedFile(fileList){
            this.$store.commit('CandidateStore/updateEvalFiles', {docs_ids: fileList} )
        }
    }
}
</script>

<style lang="scss">

.campaign_form_inputs{
    padding-top: 50px;
    position: relative;
    width: 100%;
    max-width: 700px;
    margin: auto;
    .uploader_title{
        font-weight: 500;
    }
}
.welcome_title{
    margin-bottom: 60px;
}
</style>